import * as React from 'react'
export default class SortIcon extends React.PureComponent<{
  className: string | null | undefined
  reverseDirection: boolean | null | undefined
}> {
  render(): React.ReactElement<'svg'> {
    const { className, reverseDirection } = this.props
    return (
      <svg height="17" width="10" viewBox="0 0 10 17" className={className}>
        <g transform={reverseDirection ? null : 'rotate(-180 4.9 8.5)'}>
          <path
            d="M4.11 6l-.413.283a.5.5 0 0 0 .825 0L4.109 6zM0 0v-.5a.5.5 0 0 0-.413.783L0 0zm8.219 0l.412.283A.5.5 0 0 0 8.22-.5V0zM4.522 5.717l-4.11-6-.825.566 4.11 6 .825-.566zM0 .5h8.219v-1H0v1zm7.806-.783l-4.11 6 .826.566 4.11-6-.826-.566z"
            fill="#9B9B9B"
            transform="rotate(-180 4.5 3.5)"
          />
          <g fill="#9B9B9B" transform="translate(.78 10)">
            <path d="M4.11 6L0 0h8.219l-4.11 6z" />
            <path d="M4.11 6l-.413.283a.5.5 0 0 0 .825 0L4.109 6zM0 0v-.5a.5.5 0 0 0-.413.783L0 0zm8.219 0l.412.283A.5.5 0 0 0 8.22-.5V0zM4.522 5.717l-4.11-6-.825.566 4.11 6 .825-.566zM0 .5h8.219v-1H0v1zm7.806-.783l-4.11 6 .826.566 4.11-6-.826-.566z" />
          </g>
        </g>
      </svg>
    )
  }
}
